import { ReactElement } from 'react';
import { IComponentCss } from '@tap/mui-ui';
import { Grid, Typography } from '@mui/material';
import { TooltipProps } from 'recharts';
import {
    NameType, Payload, ValueType,
} from 'recharts/types/component/DefaultTooltipContent';
import { CSSObject } from '@mui/material/styles';

/*
*   Тултип для графиков
*/

type ICustomChartTooltip = {
    labelTemplate: (label: string | number | Date | undefined) => string | number | Date | ReactElement | undefined,
    valueTemplate: (label: Payload<ValueType, NameType>) => string | number | Date | ReactElement | undefined,
    labelSx?: CSSObject,
} & TooltipProps<ValueType, NameType>

const css: IComponentCss = {
    wrap: {
        background: '#ffffff',
        padding: '12px',
        borderRadius: '4px',
        border: '1px solid #B3B3B3',
    },
    title: {
        marginBottom: '6px',
    },
};


export function CustomChartTooltip({
    labelTemplate,
    valueTemplate,
    active,
    payload,
    label,
    labelSx = undefined,
}: ICustomChartTooltip) {
    if (active && payload && payload.length) {
        return (
            <Grid sx={css.wrap}>
                <Typography sx={{ ...css.title, ...labelSx }}>
                    {labelTemplate(label)}
                </Typography>
                <Grid>
                    {payload.map((pld, i) => (
                        <Typography
                            key={pld.name + i.toString()}
                            sx={{ color: pld.color }}
                        >
                            {valueTemplate(pld)}
                        </Typography>
                    ))}
                </Grid>
            </Grid>
        );
    }

    return null;
}